import * as constants from '@/store/constants'

const state = {
  sreUse: 'true',
  gender: 'male',
  difficulty: '3',
  answerSound: 'true',
  autoScreenTransition: 'true',
  showJapanese: false,
  showAllAnswer: false,
  textSize: constants.TEXT_SIZE_SETTING_MIDDLE,
  popupDictionaryUse: "true"
}

const getters = {
  sreUse(state) {
    return state.sreUse
  },
  gender(state) {
    return state.gender
  },
  difficulty(state) {
    return state.difficulty
  },
  answerSound(state) {
    return state.answerSound
  },
  autoScreenTransition(state) {
    return state.autoScreenTransition
  },
  showJapanese(state) {
    return state.showJapanese
  },
  showAllAnswer(state) {
    return state.showAllAnswer
  },
  textSize(state) {
    return state.textSize
  },
  popupDictionaryUse(state) {
    return state.popupDictionaryUse;
  }
}

const actions = {
  setSreUse({commit}, sreUse) {
    commit('setSreUse', sreUse)
  },
  setGender({commit}, gender) {
    commit('setGender', gender)
  },
  setDifficulty({commit}, difficulty) {
    commit('setDifficulty', difficulty)
  },
  setAnswerSound({commit}, answerSound) {
    commit('setAnswerSound', answerSound)
  },
  setAutoScreenTransition({commit}, autoScreenTransition) {
    commit('setAutoScreenTransition', autoScreenTransition)
  },
  setShowJapanese({commit}, showJapanese) {
    commit('setShowJapanese', showJapanese)
  },
  setShowAllAnswer({commit}, showAllAnswer) {
    commit('setShowAllAnswer', showAllAnswer)
  },
  setTextSize({commit}, textSize) {
    commit('setTextSize', textSize)
  },
  setPopupDictionaryUse({ commit }, popupDictionaryUse) {
    commit("setPopupDictionaryUse", popupDictionaryUse);
  }
}

const mutations = {
  setSreUse(state, sreUse) {
    state.sreUse = sreUse
  },
  setGender(state, gender) {
    state.gender = gender
  },
  setDifficulty(state, difficulty) {
    state.difficulty = difficulty
  },
  setAnswerSound(state, answerSound) {
    state.answerSound = answerSound
  },
  setAutoScreenTransition(state, autoScreenTransition) {
    state.autoScreenTransition = autoScreenTransition
  },
  setShowJapanese(state, showJapanese) {
    state.showJapanese = showJapanese
  },
  setShowAllAnswer(state, showAllAnswer) {
    state.showAllAnswer = showAllAnswer
  },
  setTextSize(state, textSize) {
    state.textSize = textSize
  },
  setPopupDictionaryUse(state, popupDictionaryUse) {
    state.popupDictionaryUse = popupDictionaryUse;
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/setting.js